// extracted by mini-css-extract-plugin
module.exports = {"formPartWrapper":"Condition_formPartWrapper__3ZV7L","error":"Condition_error__2XHK3"};